export default __webpack_public_path__ + "static/media/money.d3bf391f.svg";